import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);


//////////////////
// WEBPACK FOOTER
// ./plugins/vee-validate.js
// module id = ./plugins/vee-validate.js
// module chunks = 54